module.exports = __webpack_public_path__ + "static/media/logo2.7f935e67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo2.png
// module id = 915
// module chunks = 1